import React from 'react';
import { Link } from '@nexus/lib-react/dist/core/Button/ButtonBase';
import { useI18n } from '@olxeu-a2b/ui/src/i18n';
import { Global, css } from '@emotion/core';
import { ConfirmationPage } from '@nexus/lib-react/dist/core/ConfirmationPage/ConfirmationPage';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import { Headline5 } from '@nexus/lib-react/dist/core/Typography/Heading';
import mq from '../../styles/mediaQueries';
import S from './BenefitsDisabledStyle';

const BenefitsDisabled = ({ redirectUrl }: { redirectUrl: string }) => {
  const i18n = useI18n();

  return (
    <S.Wrapper>
      <Global
        styles={css`
          #page-header-desktop {
            display: none;

            ${mq.tablet} {
              display: flex;
            }
          }
        `}
      />
      <S.PageWrapper>
        <ConfirmationPage pageType="info">
          <S.DroppedIceCreamIcon />
          <Headline5 mb={24}>{i18n`dlv_benefits_disabled_headline`}</Headline5>
          <ButtonPrimaryDark as={Link} href={redirectUrl} mb={16}>
            {i18n`dlv_benefits_disabled_redirect_button`}
          </ButtonPrimaryDark>
        </ConfirmationPage>
      </S.PageWrapper>
    </S.Wrapper>
  );
};

export default BenefitsDisabled;
